import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
declare const swal: any;
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  changepwdForm: FormGroup;
  loading: any = false;
  constructor(private form: FormBuilder, private router: Router, private afauth: AngularFireAuth,
    public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.changepwdForm = this.form.group({
      oldpassword: ['', [Validators.required]],
      newpassword: ['', [Validators.required]],
      confirmnewpassword: ['', [Validators.required]]
    });
  }

  changepwd(value, valid) {
    if (valid) {
      if (value.newpassword != value.confirmnewpassword) { this.toastr.error('password doesn\'t match!', 'Oops!'); return false; }
      this.loading = true;
      const currentuser = this.afauth.auth.currentUser;
      this.afauth.auth.signInWithEmailAndPassword(currentuser.email, value.oldpassword).then(crediential => {
        this.afauth.auth.currentUser.updatePassword(value.newpassword).then(success => {
          this.loading=false;
             swal('success!', 'password changed successfully.', 'success')  
          this.router.navigate(['/']);
        }, error => {
          this.loading = false;
          this.toastr.error('Somthing went wrong please try again later', 'Oops!!');
        });
      }, error => {
        this.loading = false;
        this.toastr.error('Enter the Correct old password!', 'Oops!');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/extras/change-password/change-password.component.ts